var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"item-value":"value","item-text":"text"},on:{"change":_vm.handleChange},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }